import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Translation from '../../lang/Translation';
import CV2Card from '../ui/svg/CV2Tooltip/cv2-3digit.svg';
import CV2Amex from '../ui/svg/CV2Tooltip/cv2-4digit.svg';
import useStyles from './CV2Helper.styles';

export function CV2Helper(props) {
  const classes = useStyles();
  
  const amexDetails = () => (
    <div>
      <img data-test="card-img" className={classes.cardImage} src={CV2Amex} alt="" />
      <div data-test="card-details" className={classes.cardDetails}>
        <div
          className="card-title"
        >
          <Translation>checkout.payment.method.field.cv2.overlay.text.amex.title</Translation>
        </div>
        <Translation>checkout.payment.method.field.cv2.overlay.text.amex.description</Translation>
      </div>
    </div>
  );
  
  return (
    <div data-test="cv2-helper-text-container" className={classes.textContainer}>
      <div>
        <img data-test="card-img" className={classes.cardImage} src={CV2Card} alt="" />
        <div data-test="card-details" className={classes.cardDetails}>
          <span className="card-title">
            <Translation>checkout.payment.method.field.cv2.overlay.text.3digit.title</Translation>
          </span>
          <Translation>checkout.payment.method.field.cv2.overlay.text.3digit.description</Translation>
        </div>
        {props.acceptedCardTypes?.includes('amex') && amexDetails()}
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  acceptedCardTypes: state.start.acceptedCardTypes,
});

CV2Helper.propTypes = {
  acceptedCardTypes: PropTypes.array.isRequired,
};

export default connect(
  mapStateToProps,
)(CV2Helper);
